/**
 *
 * UserEditForm
 *
 */
import { Component, useEffect, useState } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import Header from "basicComponents/Header/Header";
import DataTable from "basicComponents/DataTable/DataTable";
import { getUserId, updateUserData } from "utils/userStorage";
import messages from "./messages";
import {generateCodeVerifier,generateCodeChallengeFromVerifier, parseJwt} from 'utils/OauthUtils'
import RefrezhButton from "components/RefrezhButton";
import { getBearer } from "utils/userStorage";

class UserEditForm extends Component {
  static propTypes = {
    onLanguageChanged: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    onUpdateUser: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired,
    passwordFailed: PropTypes.object.isRequired,
    passwordInProgress: PropTypes.bool,
    languages: PropTypes.array.isRequired,
    userFailed: PropTypes.object.isRequired,
    userInProgress: PropTypes.bool.isRequired,
  };

  state = {
    firstName: this.props.user.firstName,
    lastName: this.props.user.lastName,
    language: this.props.user.languageId,
    email: this.props.user.email,
    phoneNumber: this.props.user.phoneNumber || "",
    languageName: this.props.user.language,
  };

  handleLanguageChanged = languageId => {
    const language = this.props.languages.find(
      lang => lang.language === languageId,
    );

    this.setState({
      language: language.id,
      languageName: language.language,
    });
  };

  handleFirstNameChanged = e => {
    this.setState({
      firstName: e.target.value,
    });
  };

  handleLastNameChanged = e => {
    this.setState({
      lastName: e.target.value,
    });
  };

  handleConfirm = () => {
    const user = {
      id: this.props.user.id,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.props.user.email,
      phoneNumber: this.state.phoneNumber,
      languageId: this.state.language,
      language: this.state.languageName,
    };

    this.props.onUpdateUser(user, () => {
      updateUserData(user);
      const language = this.props.languages.find(
        lang => lang.id === this.state.language,
      );
      this.props.onLanguageChanged(language.language);
    });
  };

  handlePhoneChanged = e => {
    this.setState({
      phoneNumber: e.target.value,
    });
  };

  handleEmailChanged = e => {
    this.setState({
      email: e.target.value,
    });
  };

  componentDidMount(){
    var verifier = generateCodeVerifier()
    localStorage.setItem('verifier',verifier)
    generateCodeChallengeFromVerifier(verifier).then(challenge => {
      this.setState({challenge})
    })
  }

  render() {
    const currentLanguageIndex = this.props.languages.findIndex(
      language => language.id === this.state.language,
    );
    const currentLanguage = this.props.languages[currentLanguageIndex];

    return (
      <Wrapper data-cy="userEditForm">
        <Content>
          <Header>
            <FormattedMessage {...messages.changeUserInfo} />
          </Header>
          <DataTableWrapper style={{background:"white"}}>
            <DataTable
              debug
              disabled={this.props.disabled}
              editIcon
              noScroll
              handleConfirm={this.handleConfirm}
              items={[
                [
                  {
                    label: <FormattedMessage {...GlobalMessages.first_name} />,
                    value: this.state.firstName,
                    onChange: this.handleFirstNameChanged,
                    userFailed: this.props.userFailed,
                    id: "firstName",
                    hideDeleteIcon: true,
                  },
                  {
                    label: <FormattedMessage {...GlobalMessages.last_name} />,
                    value: this.state.lastName,
                    onChange: this.handleLastNameChanged,
                    userFailed: this.props.userFailed,
                    id: "lastName",

                    hideDeleteIcon: true,
                  },
                  {
                    label: <FormattedMessage {...GlobalMessages.email} />,
                    value: this.state.email,
                    disableIcon: true,
                    onChange: this.handleEmailChanged,
                    userFailed: this.props.userFailed,
                    id: "email",

                    hideDeleteIcon: true,
                  },
                  {
                    label: <FormattedMessage {...GlobalMessages.language} />,
                    value: currentLanguage ? (
                      currentLanguage.language
                    ) : (
                      <FormattedMessage {...GlobalMessages.unavailable} />
                    ),
                    onChange: this.handleLanguageChanged,
                    userFailed: this.props.userFailed,
                    dropDown: true,
                    dropDownItems: this.props.languages,
                    dropDownValue: currentLanguageIndex,
                    id: "language",

                    hideDeleteIcon: true,
                  },
                ],
              ]}
            />
          </DataTableWrapper>
          {/* <Threeshapelogin></Threeshapelogin>
          {(() => {
            if(this?.state?.challenge){
              // 'http://localhost:3000/oauthcallback'
              let clientid = __URLS__["clientid"]
              let identitybaseurl = __URLS__["threeshapeidentity"]
              let redirecturi = window.location.origin + '/oauthcallback' 
              return <a href={`${identitybaseurl}/connect/authorize?client_id=${clientid}&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=${redirecturi}&code_challenge=${this.state.challenge}&code_challenge_method=S256&response_mode=query`} onClick={(e) => {
                localStorage.setItem('oauthreferrer',window.location.href)
              }} >
                3shape login
              </a>
            }
          })()}
          {(() => {
            var jwt = JSON.parse(localStorage.getItem('jwt'))
            if(jwt && jwt.exp > (Date.now() / 1000)){
              return <span>currently logged in</span>
            }
          })()} */}
          <WarningField>
            {this.props.userFailed.messages.map(message => (
              <div className="registerWarning" key={message}>
                - {message}
              </div>
            ))}
          </WarningField>
        </Content>
      </Wrapper>
    );
  }
}

function Threeshapelogin(){

    let [challenge,setchallenge] = useState(null)
    let [verifier,setverifier] = useState(null)
    useEffect(() => {
      let ver = generateCodeVerifier()
      setverifier(ver)
      // localStorage.setItem('verifier',verifier)
      generateCodeChallengeFromVerifier(ver).then(challenge => {
        setchallenge(challenge)
      })
    },[])

    let clientid = __URLS__["clientid"]
    let identitybaseurl = __URLS__["threeshapeidentity"]
    let redirecturi = window.location.origin + '/oauthcallback'
    if(challenge != null){
      return <RefrezhButton>
        <a href={`${identitybaseurl}/connect/authorize?client_id=${clientid}&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=${redirecturi}&code_challenge=${challenge}&code_challenge_method=S256&response_mode=query`} onClick={(e) => {
          localStorage.setItem('verifier',verifier)
          localStorage.setItem('oauthreferrer',window.location.href)
        }} >
          3shape login
        </a>
      </RefrezhButton>
    }else{
      return <div>challenge not found</div>
    }
}

window.Threeshapelogin = Threeshapelogin

const DataTableWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;

  @media (max-width: 500px) {
    overflow: auto;
  }
`;

const WarningField = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.margin}rem;
  color: ${({ theme }) => theme.palette.error.main};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.phone`
    flex-direction: column;
  `};

  @media (min-width: 1315px) {
    width: 30rem;
  }
`;

const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  /* width: calc(50% - ${({ theme }) => theme.margin / 2}rem); */
  ${({ theme }) => theme.phone`
    margin-top: ${theme.margin}rem;
    &:first-child {
      margin-top: 0;
    }
    width: 100%;
  `};
`;

export default UserEditForm;
